<template>
  <div>
    <div v-show="visible_doc" class="docTable">
      <a-drawer
        :title="previewFileName"
        placement="left"
        width="55%"
        @close="onClose"
        :visible="isPreviewVisible"
      >
        <a-spin :spinning="spinningPreview">
          <div v-if="!isImage && docPdf" style="position: relative; margin: 15px">
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding-bottom: 5px;
              "
            >
              <a-button
                :disabled="currentPage - 1 < 1 ? true : false"
                @click="
                  () => {
                    currentPage--;
                    preview(fileSave);
                  }
                "
              >
                <a-icon type="left" />
                {{ $t("Prev") }}
              </a-button>
              <span>{{ currentPage }} / {{ countPages }}</span>
              <a-button
                :disabled="currentPage + 1 > countPages ? true : false"
                @click="
                  () => {
                    currentPage++;
                    preview(fileSave);
                  }
                "
              >
                {{ $t("Next") }}
                <a-icon type="right" />
              </a-button>
            </div>
            <div style="position: relative">
              <canvas id="pdf-canvas-drawer" class="pdf-canvas"></canvas>
              <div id="text-layer-drawer" class="text-layer"></div>
            </div>
            <div style="display: flex; justify-content: space-between">
              <a-button
                :disabled="currentPage - 1 < 1 ? true : false"
                @click="
                  () => {
                    currentPage--;
                    preview(fileSave);
                  }
                "
              >
                <a-icon type="left" />
                {{ $t("Prev") }}
              </a-button>
              <span>{{ currentPage }} / {{ countPages }}</span>
              <a-button
                :disabled="currentPage + 1 > countPages ? true : false"
                @click="
                  () => {
                    currentPage++;
                    preview(fileSave);
                  }
                "
              >
                {{ $t("Next") }}
                <a-icon type="right" />
              </a-button>
            </div>
          </div>

          <img v-else-if="isImage" :src="`${docPdf}`" style="width: 100%" />
        </a-spin>
      </a-drawer>

      <div class="documentSearch">
        <div class="functionalRow">
          <!-- <a-upload
            :fileList="invoices"
            :beforeUpload="beforeUpload"
            style="margin-right: 15px;"
            :multiple="true"
          >
            <a-button
              type="primary"
              icon="upload"
              :loading="uploadingUpload"
              :disabled="isUploadingDisable"
            />
          </a-upload> -->
          <a-button
            type="primary"
            @click="
              () => {
                visibleControlColumnsModal = true;
              }
            "
            :disabled="!selectedRowKeys.length"
            style="margin-right: 15px"
            icon="file-excel"
            :loading="uploadingExcel"
          />
          <a-modal
            v-model="visibleControlColumnsModal"
            :title="
              selectedRowKeys.length ? 'Pola do eksportu' : 'Widoczne pola'
            "
            width="560px"
          >
            <invoiceTableTransfer
              :controlTableColumns="controlTableColumns"
              ref="invoiceTableTransfer"
            />
            <template slot="footer">
              <a-row type="flex" justify="space-between">
                <div>
                  <a-button
                    type="primary"
                    icon="save"
                    @click="handlerSaveReport"
                    style="margin-right: 15px"
                  />
                  <a-auto-complete
                    v-model="reportInputValue"
                    :data-source="Object.keys(InitInfo.reports.invoices)"
                    style="width: 200px; border-radius: 0; margin-right: 15px"
                    :placeholder="$t('Report name')"
                    @select="handlerSelectReport"
                  />
                  <a-button
                    icon="delete"
                    style="color: #ff4d4f"
                    @click="handlerDeleteReport"
                  />
                </div>
                <div>
                  <a-tooltip
                    title="Ustaw jako domyślne dla wszystkich"
                    v-if="profile.ADMIN"
                  >
                    <a-switch
                      :checked="isAdminOptionChecked"
                      @change="(val) => (isAdminOptionChecked = val)"
                    >
                      <a-icon slot="checkedChildren" type="check" />
                      <a-icon slot="unCheckedChildren" type="close" />
                    </a-switch>
                  </a-tooltip>

                  <a-button
                    key="submit"
                    type="primary"
                    @click="handlerReportModalSubmit"
                    >{{
                      $t(selectedRowKeys.length ? "Export" : "Save")
                    }}</a-button
                  >
                </div>
              </a-row>
            </template>
          </a-modal>
          <a-row type="flex" class="search-wrapper">
            <a-col style="flex: 1; margin-right: 15px">
              <a-dropdown :trigger="['click']">
                <a-input-search
                  class="ant-dropdown-link"
                  @search="(e) => handleSearch({ text: e })"
                  v-model="searchlabel"
                  :placeholder="$t('Search by name')"
                />
                <a-menu slot="overlay" style="background-color: #fafafa">
                  <a-form
                    :form="form"
                    id="my_form_search_styl"
                    layout="vertical"
                    style="padding: 0 50px"
                  >
                    <a-menu-item key="2">
                      <a-form-item :label="$t('Status')">
                        <a-select
                          mode="multiple"
                          allowClear
                          optionFilterProp="children"
                          v-model="searchStatus"
                        >
                          <template v-for="item in statusList">
                            <a-select-option :key="item.name">{{
                              $t(item.name)
                            }}</a-select-option>
                          </template>
                        </a-select>
                      </a-form-item>
                      <a-form-item :label="$t('Keywords')">
                        <a-select
                          mode="multiple"
                          allowClear
                          optionFilterProp="children"
                          v-decorator="[
                            'tags',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option v-for="i in key_words" :key="i">{{
                            i
                          }}</a-select-option>
                        </a-select>
                      </a-form-item>

                      <a-form-item :label="$t('CompanyName')">
                        <a-input
                          @click="handleChangeMyCompany()"
                          v-model="companyTitle"
                        />
                      </a-form-item>

                      <a-form-item :label="$t('Main Company')" hidden>
                        <a-select
                          mode="multiple"
                          allowClear
                          optionFilterProp="children"
                          v-decorator="[
                            'my_company',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option
                            v-for="itm in MY_COMPANY_LIST"
                            :key="itm.ID"
                            >{{ itm.TITLE }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>

                      <a-form-item :label="$t('Contractor')" hidden>
                        <a-select
                          mode="multiple"
                          allowClear
                          optionFilterProp="children"
                          v-decorator="[
                            'kontragent',
                            {
                              rules: [{ required: false }],
                              initialValue:
                                placementCompanyID === false
                                  ? []
                                  : [placementCompanyID],
                            },
                          ]"
                        >
                          <a-select-option
                            v-for="itm in COMPANY_LIST"
                            :key="itm.ID"
                            >{{ itm.TITLE }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>

                      <a-form-item :label="$t('Kontrahent')">
                        <a-input
                          @click="handleChangeContractor()"
                          v-model="contractorTitle"
                        />
                      </a-form-item>

                      <a-form-item :label="$t('Cost centers')">
                        <a-select
                          mode="multiple"
                          allowClear
                          optionFilterProp="children"
                          v-decorator="[
                            'cost_center',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option
                            v-for="itm in user_setup.MPK"
                            :key="itm"
                            >{{ itm }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>

                      <a-form-item :label="$t('Cost types')">
                        <a-select
                          mode="multiple"
                          allowClear
                          optionFilterProp="children"
                          v-decorator="[
                            'cost_type',
                            { rules: [{ required: false }] },
                          ]"
                        >
                          <a-select-option
                            v-for="itm in user_setup.CostTypes"
                            :key="itm"
                            >{{ itm }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="3">
                      <a-form-item :label="$t('Project')">
                        <a-select
                          mode="multiple"
                          allowClear
                          optionFilterProp="children"
                          @search="onSearchDeal"
                          v-decorator="[
                            'cost_deal',
                            {
                              rules: [{ required: false }],
                              initialValue:
                                placementDealID === false
                                  ? []
                                  : [placementDealID],
                            },
                          ]"
                        >
                          <a-select-option
                            v-for="item in DEAL_LIST"
                            :key="item.ID"
                            >{{ item.TITLE }}</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-menu-item>
                    <a-menu-item key="4"></a-menu-item>
                    <a-menu-item key="5">
                      <a-form-item :label="$t('File creation date')">
                        <a-range-picker
                          allowClear
                          v-decorator="[
                            'CREATE_TIME',
                            { rules: [{ type: 'array', required: false }] },
                          ]"
                        />
                      </a-form-item>
                      <a-form-item :label="$t('Date of issue')">
                        <a-range-picker
                          allowClear
                          v-decorator="[
                            'date_recept',
                            { rules: [{ type: 'array', required: false }] },
                          ]"
                        />
                      </a-form-item>
                    </a-menu-item>

                    <a-menu-item key="6">
                      <a-form-item
                        style="text-align: center"
                        :label-col="{ span: 0 }"
                        :wrapper-col="{ span: 24 }"
                      >
                        <a-button type="primary" @click="handleSearch()">{{
                          $t("Search")
                        }}</a-button>
                        <a-button
                          @click="handleReset()"
                          style="margin-left: 50px"
                          >{{ $t("Reset") }}</a-button
                        >
                      </a-form-item>
                    </a-menu-item>
                  </a-form>
                </a-menu>
              </a-dropdown>
            </a-col>
            <a-col style="margin-right: 15px">
              <a-button
                type="primary"
                :icon="iconCheck"
                @click="
                  !iconCheck
                    ? handleSearch({ status: ['ZAAKCEPTOWANE'] })
                    : handleReset()
                "
                >{{ $t("ZAAKCEPTOWANE FILTER") }}</a-button
              >
            </a-col>
            <a-col>
              <a-button
                type="primary"
                icon="control"
                :disabled="selectedRowKeys.length != 0"
                @click="() => (visibleControlColumnsModal = true)"
              />
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="documentTable">
        <a-table
          :locale="locale"
          :columns="tableColumns.selected"
          :dataSource="invoices"
          :pagination="{
            'show-size-changer': true,
            showTotal: (total) => `${this.$t('Total')} ${total}`,
          }"
          tableLayout="auto"
          :scroll="{ x: true }"
          size="middle"
          @change="handleChange"
          :row-selection="rowSelection"
          bordered
        >
          <template
            slot="name"
            slot-scope="text, record"
            style="text-align: left"
          >
            <a @click="goSteps(record)" style="text-align: left; padding: 0">{{
              text
            }}</a>
          </template>
          <template slot="time_change" slot-scope="text">{{
            text || ""
          }}</template>
          <template slot="preview" slot-scope="text, record, index">
            <a-button @click="previewFile(record)" type="link" icon="eye" />
            <a-popconfirm
              :title="$t('Delete file?')"
              v-show="record.status != 'ZAAKCEPTOWANE'"
              :ok-text="$t('Tak')"
              :cancel-text="$t('Nie')"
              @confirm="handleDeleteFile(record, index)"
              :disabled="!checkResponsible"
            >
              <a-button type="link">
                <a-icon
                  type="delete"
                  :style="{ color: checkResponsible ? '#ff4d4f' : '#949494' }"
                />
              </a-button>
            </a-popconfirm>
          </template>
          <template slot="footer">
            <a-row type="flex" justify="space-around" align="middle">
              <a-statistic
                v-for="(item, key) in statisticQuota"
                :key="key"
                :title="$t(key)"
                :value="item"
                :precision="2"
              />
            </a-row>
          </template>
        </a-table>
      </div>
      <statisticFromStatus
        :handleSearch="handleSearch"
        :statusList="statusList"
      />
    </div>
    <steps
      v-if="!visible_doc"
      :element="document_record"
      :statusList="statusList"
      :COMPANY_LIST="COMPANY_LIST"
      :MY_COMPANY_LIST="MY_COMPANY_LIST"
      :USER_LIST="USER_LIST"
      :profile="profile"
      :form_info="InitInfo"
      :responsible="responsible"
      :fieldColumns="tableColumns.all"
      :disableFromResponsible="disableFromResponsible"
      :current="current"
      :specialization="specialization"
      :user_setup="user_setup"
      :previewElement="previewElementOnSteps"
      @preview="onpreview"
      @ReturnToStepBack="handleReturnToStepBack"
      @back="onback"
      :key_words="key_words"
    />
  </div>
</template>
<script>
import en_GB from "ant-design-vue/lib/locale-provider/en_GB";
import pl_PL from "ant-design-vue/lib/locale-provider/pl_PL";
import ru_RU from "ant-design-vue/lib/locale-provider/ru_RU";
import steps from "./invoices_steps.vue";
import invoiceTableTransfer from "./invoiceTableTransfer";
import statisticFromStatus from "./statisticFromStatus";
import { mapMutations } from "vuex";
import moment from "moment";
import {
  getInvoices,
  getDocumentAllStage,
  getFilterInvoice,
  uploadFile,
  getPoglad,
  returnToStepBack,
  getExcel,
  saveReports,
  deleteFile,
} from "@/requestFunc";
var pdfjsLib = require("pdfjs-dist/build/pdf");
var pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");

// var pdfjsLib = require("pdfjs-dist/build/pdf");

export default {
  components: {
    steps,
    invoiceTableTransfer,
    statisticFromStatus,
  },
  props: [
    "InitInfo",
    "key_words",
    "specialization",
    "responsible",
    "user_setup",
    "COMPANY_LIST",
    "MY_COMPANY_LIST",
    "DEAL_LIST",
    "USER_LIST",
    "goToInvoiceData",
    "placementDealID",
    "placementCompanyID",
  ],
  data() {
    return {
      en_GB,
      pl_PL,
      ru_RU,
      locale: ru_RU,
      form: this.$form.createForm(this, { name: "search" }),
      searchStatus: [],
      countPages: 1,
      currentPage: 1,
      reportInputValue: "",
      searchlabel: "",
      isUploadingDisable: true,
      visibleControlColumnsModal: false,
      previewElementOnSteps: {},
      selectedRowKeys: [],
      FILTERED_DEAL_LIST: {},
      isAdminOptionChecked: false,
      fileSave: "",
      domain: "",
      statusList: [
        { name: "ZAREJESTROWANE", color: "#029C8E" },
        { name: "OPISANE FVK", color: "#2C7FE4" },
        { name: "ROZKSIEKOWANE", color: "#ffb174" },
        { name: "PLATNOSC", color: "#b55c6c" },
        { name: "AKCEPTACJA", color: "#775ada" },
        { name: "ZAAKCEPTOWANE", color: "#303a52" },
      ],
      isPreviewVisible: false,
      spinningPreview: true,
      previewFileName: "",
      isImage: false,
      invoices: [],
      addFileList: [],
      iconCheck: undefined,
      uploadingExcel: false,
      uploadingXml: false,
      uploadingUpload: false,
      contractorTitle: "",
      companyTitle: "",
      sortedInfo: { sort_column: undefined, sort_order: undefined },
      filterInfo: {},
      profile: {},
      part_max: 0,
      docPdf: false,
      visible_doc: true,
      document_record: null,
      current: 0,
      disableFromResponsible: false,
      tableColumns: {
        selected: [],
        all: [
          {
            title: this.$t("Invoice number"),
            dataIndex: "num_doc",
            ellipsis: true,
          },
          {
            title: this.$t("Date of change"),
            key: "time_change",
            //FIXME сортировка по умолчанию не пашет
            defaultSortOrder: "descend",
            sorter: (a, b) =>
              this.sortField(a.time_change, b.time_change, (x) =>
                x ? new Date(x) : ""
              ),
            dataIndex: "time_change",
            scopedSlots: { customRender: "time_change" },
          },
          {
            title: this.$t("Contractor"),
            dataIndex: "kontragent",
            ellipsis: true,
            customRender: (text) => {
              if (text && this.COMPANY_LIST[text]) {
                return (
                  <a
                    href={`https://${this.domain}/crm/company/details/${text}/`}
                    target="_blank"
                  >
                    {this.COMPANY_LIST[text]["TITLE"]}
                  </a>
                );
              }
              return "";
            },
          },
          {
            title: this.$t("Main Company"),
            dataIndex: "my_company",
            ellipsis: true,
            customRender: (text) => {
              if (text && this.COMPANY_LIST[text]) {
                return (
                  <a
                    href={`https://${this.domain}/crm/company/details/${text}/`}
                    target="_blank"
                  >
                    {this.COMPANY_LIST[text]["TITLE"]}
                  </a>
                );
              }
              return "";
            },
          },
          {
            title: this.$t("Date of issue"),
            key: "date_recept",
            sorter: (a, b) =>
              this.sortField(a.date_recept, b.date_recept, (x) =>
                x ? new Date(x) : ""
              ),
            dataIndex: "date_recept",
          },
          {
            title: this.$t("Tag"),
            key: "Teczka",
            align: "center",
            dataIndex: "Teczka",
            customRender: (text) => {
              var mas = [];
              if (text) {
                for (let itm of text) {
                  mas.push(<a-tag color="blue">{itm}</a-tag>);
                }
              }
              return mas;
            },
          },
          {
            title: this.$t("Keywords"),
            key: "key_words",
            align: "center",
            dataIndex: "key_words",
            customRender: (text) => {
              var mas = [];
              if (text && text != "[]") {
                for (let itm of text) {
                  mas.push(<a-tag color="green">{itm}</a-tag>);
                }
              }
              return mas;
            },
          },
          /* {
            title: this.$t("Payment Date"),
            dataIndex: "PaymentDateReal",
            sorter: (a, b) =>
              this.sortField(a.PaymentDateReal, b.PaymentDateReal, (x) =>
                x ? new Date(x) : ""
              ),
          },*/
          {
            title: this.$t("Reminder"),
            dataIndex: "reminderDate",
            sorter: (a, b) =>
              this.sortField(a.reminderDate, b.reminderDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Planned date"),
            dataIndex: "plannedDate",
            sorter: (a, b) =>
              this.sortField(a.plannedDate, b.plannedDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Kwota Brutto"),
            dataIndex: "Quota.Bruto",
            customRender: (text, record) =>
              record.Quota ? (+record.Quota.Bruto).toFixed(2) : "",
          },
          {
            title: this.$t("Kwota Netto"),
            dataIndex: "Quota.Netto",
            customRender: (text, record) =>
              record.Quota ? (+record.Quota.Netto).toFixed(2) : "",
          },
          {
            title: this.$t("Kwota Vat"),
            dataIndex: "Quota.Vat",
            customRender: (text, record) =>
              record.Quota ? (+record.Quota.Vat).toFixed(2) : "",
          },
          {
            title: "Centrum kosztu",
            dataIndex: "invoiceTable.cost_center",
            customRender: (text, record) => {
              var mas = [];
              if (record.invoiceTable) {
                for (let itm of record.invoiceTable) {
                  if (itm.sum_distribution) {
                    mas = mas.concat(
                      itm.sum_distribution.map((field) => field.mpk)
                    );
                  }
                }
              }
              return Array.from(new Set(mas)).map((x) =>
                x ? <a-tag>{x}</a-tag> : ""
              );
            },
          },
          {
            title: "Typ kosztu",
            dataIndex: "invoiceTable.cost_type",
            customRender: (text, record) => {
              var mas = [];
              if (record.invoiceTable) {
                for (let itm of record.invoiceTable) {
                  if (itm.sum_distribution) {
                    mas = mas.concat(
                      itm.sum_distribution.map((field) => field.type)
                    );
                  }
                }
              }
              return Array.from(new Set(mas)).map((x) =>
                x ? <a-tag>{x}</a-tag> : ""
              );
            },
          },
          {
            title: "Projekty",
            dataIndex: "invoiceTable.cost_deal",
            customRender: (text, record) => {
              var mas = [];
              if (!record.invoiceTable) return [];
              for (let itm of record.invoiceTable) {
                if (itm.sum_distribution) {
                  mas = mas.concat(
                    itm.sum_distribution.map((field) => field.deal)
                  );
                }
              }
              mas = Array.from(new Set(mas))
                .map((dealID) => this.DEAL_LIST[dealID] || "")
                .filter(Boolean)
                .map((deal) => (
                  <a
                    href={`https://${this.domain}/crm/deal/details/${deal.ID}/`}
                    target="_blank"
                  >
                    <a-tag color="blue">{deal.TITLE}</a-tag>
                  </a>
                ));
              return mas;
            },
          },
          {
            title: this.$t("Date of payment"),
            dataIndex: "paymentDate",
            sorter: (a, b) =>
              this.sortField(a.paymentDate, b.paymentDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Sale date"),
            dataIndex: "saleDate",
            sorter: (a, b) =>
              this.sortField(a.saleDate, b.saleDate, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Wewn. numer"),
            dataIndex: "invoiceAutoNumber",
            sorter: (a, b) =>
              this.sortField(a.invoiceAutoNumber, b.invoiceAutoNumber),
          },
          {
            title: this.$t("Zewn. numer"),
            dataIndex: "invoiceTitle",
            sorter: (a, b) => this.sortField(a.invoiceTitle, b.invoiceTitle),
          },
          {
            title: this.$t("Date of receiving"),
            dataIndex: "date_send",
            sorter: (a, b) =>
              this.sortField(a.date_send, b.date_send, (x) =>
                x ? new Date(x) : ""
              ),
          },
          {
            title: this.$t("Expired days"),
            dataIndex: "expiredDay",
            sorter: (a, b) =>
              this.sortField(a.paymentDate, b.paymentDate, (x) =>
                x
                  ? Math.floor(
                      (Date.parse(new Date()) - Date.parse(x)) / 86400000
                    )
                  : ""
              ),
            customRender: (text, record) => {
              let countDays = record.paymentDate
                ? Math.floor(
                    (Date.parse(new Date()) - Date.parse(record.paymentDate)) /
                      86400000
                  )
                : "";
              return countDays > 0 ? countDays : "";
            },
          },
          {
            title: this.$t("Currency"),
            dataIndex: "currency",
            customRender: (text) => {
              return text ? (
                <span>
                  <a-tag>{text.code}</a-tag>
                  <a-tag>{text.val}</a-tag>
                </span>
              ) : (
                ""
              );
            },
          },
          {
            title: this.$t("Payment"),
            dataIndex: "payment",
            filters: [
              {
                text: "nie zapłacona",
                value: "0",
              },
              {
                text: "zapłacona",
                value: "1",
              },
            ],
            onFilter: (value, record) =>
              value == "1"
                ? record.kwota?.paidPercent == 100
                : record.kwota?.paidPercent < 100,
            customRender: (text, record) => {
              return text ? (
                <span>
                  <a-tag>{text.type}</a-tag>
                  <a-tag>{text.date}</a-tag>
                  <a-tag color="blue">{record?.kwota?.paidPercent || 0}%</a-tag>
                </span>
              ) : (
                ""
              );
            },
          },
          {
            title: this.$t("Type"),
            dataIndex: "invoiceType",
            customRender: (text) => {
              return text == "VAT Marza" ? "Faktura do Proformy" : text;
            },
          },
          {
            title: this.$t("Bank account"),
            dataIndex: "bankAccount",
          },
          {
            title: this.$t("File creation"),
            dataIndex: "CREATE_TIME",
            sorter: (a, b) =>
              this.sortField(a.CREATE_TIME, b.CREATE_TIME, (x) =>
                x ? new Date(x) : ""
              ),
            customRender: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
          },
        ],
      },
      controlTableColumns: {
        plainOptions: [],
        checkedList: [
          this.$t("Invoice number"),
          this.$t("Date of change"),
          this.$t("Date of issue"),
          this.$t("Bank account"),
          this.$t("Main Company"),
        ],
      },
      checkResponsible: false,
    };
  },
  computed: {
    statisticQuota() {
      // let nettoTitle = this.$t('Netto');
      //let vatTitle = this.$t('Vat');
      // let bruttoTitle = this.$t('Brutto');
      //let statistic = [ { key: 'Netto', Netto: 0, title: nettoTitle }, { key: 'Vat', Vat: 0, title: vatTitle }, { key: 'Brutto', Brutto: 0, title: bruttoTitle } ];
      // FIXME смотреть по валюте
      let statistic = { Netto: 0, Vat: 0, Brutto: 0 };

      for (let record of this.invoices) {
        if (record.invoiceType == "Proforma") {
          if (record.correctionBack == "") {
            if (record.Quota) {
              let { Bruto, Netto, Vat } = record.Quota;
              statistic.Brutto += +Bruto;
              statistic.Netto += +Netto;
              statistic.Vat += +Vat;
            }
          }
        } else {
          if (record.Quota) {
            let { Bruto, Netto, Vat } = record.Quota;
            statistic.Brutto += +Bruto;
            statistic.Netto += +Netto;
            statistic.Vat += +Vat;
          }
        }
      }

      return statistic;
    },
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        onChange: this.onSelectChangeTable,
        hideDefaultSelections: true,
        selections: [
          {
            key: "all-data",
            text: this.$t("Select All Data"),
            onSelect: () => {
              if (this.selectedRowKeys.length == this.invoices.length) {
                this.selectedRowKeys = [];
              } else {
                this.selectedRowKeys = [...this.invoices.map((x) => x.key)];
              }
            },
          },
        ],
      };
    },
  },
  methods: {
    moment,
    ...mapMutations([
      "updateStatisticPercent",
      "updateStatisticNumber",
      "setStatistic",
    ]),
    handleChangeMyCompany() {
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: true,
        },
        (info) => {
          let arrayCompanyName = [];
          let arrayCompanyID = [];
          for (let name in info.company) {
            arrayCompanyName.push(info.company[name].title);
            arrayCompanyID.push(info.company[name].id.split("_")[1]);
          }
          this.companyTitle = arrayCompanyName.join();
          this.form.setFieldsValue({
            my_company: arrayCompanyID,
          });
        }
      );
    },
    handleChangeContractor() {
      BX24.selectCRM(
        {
          entityType: ["company"],
          multiple: true,
        },
        (info) => {
          let arrayCompanyName = [];
          let arrayCompanyID = [];
          for (let name in info.company) {
            arrayCompanyName.push(info.company[name].title);
            arrayCompanyID.push(info.company[name].id.split("_")[1]);
          }
          this.contractorTitle = arrayCompanyName.join();
          this.form.setFieldsValue({
            kontragent: arrayCompanyID,
          });
        }
      );
    },
    onSearchDeal(e) {
      if (e.length > 2) {
        let deals = Object.entries(this.DEAL_LIST).filter((x) =>
          x[1].TITLE.includes(e)
        );
        this.FILTERED_DEAL_LIST = Object.assign(
          {},
          this.FILTERED_DEAL_LIST,
          Object.fromEntries(deals)
        );
      }
    },
    onClose() {
      this.isPreviewVisible = false;
      this.fileSave = undefined;
      this.resize();
    },
    updateSelectedColumns() {
      let kk = [];
      for (let item of this.controlTableColumns.checkedList) {
        let f = this.tableColumns.all.find((x) => x.title == item);
        if (f) kk.push(f);
      }
      this.tableColumns.selected = kk;

      BX24.userOption.set(
        "userTableColumns",
        JSON.stringify(this.controlTableColumns.checkedList)
      );
      if (this.isAdminOptionChecked) {
        BX24.appOption.set(
          "adminTableColumns",
          JSON.stringify(this.controlTableColumns.checkedList)
        );
        this.$message.success(this.$t("List of default fields for all"));
      }

      this.tableColumns.selected = [
        {
          title: this.$t("File name"),
          key: "NAME",
          sorter: (a, b) => this.sortField(a.NAME, b.NAME),
          ellipsis: true,
          dataIndex: "NAME",
          scopedSlots: { customRender: "name" },
        },
        ...this.tableColumns.selected,
        {
          title: this.$t("Status"),
          key: "status",
          align: "center",
          sorter: (a, b) => this.sortField(a.status, b.status),
          width: 150,
          fixed: "right",
          dataIndex: "status",
          customRender: (text) => {
            let status = this.statusList.find((x) => x.name == text);
            return status ? (
              <a-tag color={status.color}>{this.$t(status.name)}</a-tag>
            ) : (
              <a-tag color={"#3C494F"}>{this.$t(text)}</a-tag>
            );
          },
        },
        {
          title: this.$t("Actions"),
          dataIndex: "DOWNLOAD_URL",
          align: "center",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "preview" },
        },
      ];
    },
    previewFile(file, page) {
      getPoglad(file.ID).done((x) => {
        let file = JSON.parse(x);
        this.currentPage = page || 1;
        this.fileSave = file;
        this.preview(file);
      });
    },
    onSelectChangeTable(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    Uint8ArrayFromBase64(base64) {
      return Uint8Array.from(window.atob(base64), (v) => v.charCodeAt(0));
    },

    preview(doc) {
      let pdfAsArray = this.Uint8ArrayFromBase64(doc.base64file);

      const mimeType = this.getMimeFromUint8Array(pdfAsArray);
      // console.log("invoiceTable 📂 Detected MIME type:", mimeType);

      // if (doc.NAME.indexOf(".jpg") != -1 || doc.NAME.indexOf(".png") != -1) {
      if (mimeType === "image/png" || mimeType === "image/jpeg") {
        // this.docPdf = doc.DOWNLOAD_URL;
        this.docPdf = `data:${mimeType};base64,${doc.base64file}`;
        this.isImage = true
        this.spinningPreview = false;
      } else {
        this.docPdf = true;
        this.spinningPreview = true;
        // var url = doc.DOWNLOAD_URL;

        pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

        //       pdfjsLib.GlobalWorkerOptions.workerSrc =
        // "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.worker.min.js";

        // var loadingTask = pdfjsLib.getDocument(url);
        var loadingTask = pdfjsLib.getDocument(pdfAsArray);
        loadingTask.promise.then(
          (pdf) => {

            try {
              this.countPages = pdf.numPages;
              if (
                1 <= this.currentPage &&
                this.countPages >= this.currentPage
              ) {
                pdf.getPage(this.currentPage).then((page) => {
                  var canvas = document.getElementById("pdf-canvas-drawer");

                  let realW = $("#pdf-canvas-drawer").width();
                  var viewport = page.getViewport({
                    scale: realW / page.getViewport({ scale: 1.0 }).width,
                  });
                  var context = canvas.getContext("2d");
                  canvas.height = viewport.height;
                  canvas.width = viewport.width;
                  var renderContext = {
                    canvasContext: context,
                    viewport: viewport,
                  };

                  page
                    .render(renderContext)
                    .promise.then(() => {
                      $("#pdf-canvas-drawer").css("border", "1px solid");
                      this.spinningPreview = false;
                      return page.getTextContent();
                    })
                    .then(function(textContent) {
                      var pdf_canvas = $("#pdf-canvas-drawer");

                      var canvas_height = pdf_canvas.get(0).height;
                      var canvas_width = pdf_canvas.get(0).width;

                      $("#text-layer-drawer").css({
                        left: "2px",
                        top: "2px",
                        height: canvas_height + "px",
                        width: canvas_width + "px",
                      });
                      pdfjsLib.renderTextLayer({
                        textContent: textContent,

                        container: $("#text-layer-drawer").get(0),
                        viewport,
                        textDivs: [],
                      });
                    });
                });
              }
            } catch (error) {
              console.error({ error });

              this.spinningPreview = false;
            }
          },
          (reason) => {
            this.spinningPreview = false;
            console.error({ reason });
          }
        );
      }
      this.previewFileName = doc.NAME;
      this.isPreviewVisible = true;

    },

    getMimeFromUint8Array(uint8Array) {
      const header = Array.from(uint8Array.slice(0, 4))
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
      switch (header) {
        case "25504446":
          return "application/pdf"; // %PDF
        case "89504e47":
          return "image/png"; // PNG
        case "ffd8ffe0": // fallthrough
        case "ffd8ffe1":
        case "ffd8ffe2":
          return "image/jpeg"; // JPG
        default:
          return "unknown";
      }
    },

    beforeUpload(file) {
      this.addFileList = [...this.addFileList, file];
      this.handleUploadFile();
      return false;
    },
    handleUploadFile() {
      var formData = new FormData();
      formData.append("run", "addfile");
      formData.append("invoice", true);
      formData.append("folder", this.InitInfo.user_folder);
      this.addFileList.forEach((file) => {
        formData.append("files[]", file);
      });
      this.uploadingUpload = true;
      uploadFile(formData)
        .done((x) => {
          var res = JSON.parse(x);
          this.addFileList = [];
          this.uploadingUpload = false;
          if (res["result"] == "success") {
            res.file["time_change"] = this.moment().format(
              "YYYY-DD-MM HH:mm:ss"
            );
            res.file["key"] = this.invoices.length;
            this.invoices.unshift(res["file"]);
            this.updateStatisticPercent({
              status: res.file.status,
              isDelOrAdd: false,
            });
            this.$message.success(this.$t("Upload successful") + ".");
            this.resize();
          } else {
            this.$message.error(this.$t("Upload failed") + ".");
          }
        })
        .fail((e) => {
          this.uploadingUpload = false;
          console.error(e);
          this.$message.error(this.$t("Upload failed") + ".");
        });
    },
    handleSearch({ status = [], text = "", cost_deal, kontragent } = {}) {
      this.form.validateFields((err, values) => {
        let disp = $(".ant-dropdown-placement-bottomLeft").css("display");
        if (disp != "none" && disp != undefined) {
          $(".search-wrapper input").click();
        }
        if (values.date_recept) {
          values["date_recept"] = values.date_recept.length
            ? [
                moment(values.date_recept[0]).format("YYYY-MM-DD"),
                moment(values.date_recept[1]).format("YYYY-MM-DD"),
              ]
            : undefined;
        }
        if (values.CREATE_TIME) {
          values["CREATE_TIME"] = values.CREATE_TIME.length
            ? [
                moment(values.CREATE_TIME[0]).format("YYYY-MM-DD"),
                moment(values.CREATE_TIME[1]).format("YYYY-MM-DD"),
              ]
            : undefined;
        }
        if (text || this.searchlabel) {
          values["title"] = text || this.searchlabel;
        }
        if (cost_deal) {
          values["cost_deal"] = cost_deal;
        }
        if (kontragent) {
          values["kontragent"] = kontragent;
        }
        if (status.length) {
          this.searchStatus = status;
          this.iconCheck = "check";
        } else {
          this.iconCheck = undefined;
        }
        values["status"] = this.searchStatus;
        this.changeSpinning(true);
        this.filterInfo = values;
        getFilterInvoice("invoice", values)
          .done((data) => {
            var elem = JSON.parse(data);
            for (let i in elem) elem[i]["key"] = i;
            this.invoices = elem;
          })
          .fail((e) => {
            console.err(e);
            this.$message.error(this.$t("Error loading files"));
          })
          .always(() => {
            this.changeSpinning(false);
          });
      });
    },
    handleReset() {
      if (
        $(".ant-dropdown-placement-bottomLeft").css("display") != "none" &&
        $(".ant-dropdown-placement-bottomLeft").css("display") != undefined
      ) {
        $(".search-wrapper input").click();
      }
      this.changeSpinning(true);
      this.form.resetFields();
      this.searchStatus = [];
      this.filterInfo = {};
      this.contractorTitle = "";
      this.companyTitle = "";
      this.sortedInfo = { sort_column: undefined, sort_order: undefined };
      this.iconCheck = undefined;
      getFilterInvoice("invoice")
        .done((data) => {
          let elem = JSON.parse(data);
          for (let i in elem) elem[i]["key"] = i;
          this.invoices = elem;
        })
        .fail((e) => {
          console.err(e);
          this.$message.error(this.$t("Error loading files"));
        })
        .always(() => {
          this.changeSpinning(false);
        });
    },
    handleChange() {
      this.resize();
    },
    sortField(a, b, toTheValue) {
      if (toTheValue) {
        a = toTheValue(a);
        b = toTheValue(b);
      }
      if (a > b) {
        return 1;
      } else if (a < b) {
        return -1;
      }
      return 0;
    },
    handleDeleteFile(file, index) {
      this.changeSpinning(true);
      deleteFile(file.mainid, file.ID)
        .done((res) => {
          if (res == "success") {
            let deleteFile = this.invoices.splice(index, 1);
            this.updateStatisticPercent({
              status: this.statusList.find((x) => x.name == file.status)?.name,
              isDelOrAdd: true,
            });
            this.resize();
            this.$notification.success({
              message: "File deleted",
              description: deleteFile.NAME,
            });
          } else {
            this.$notification.error({
              message: this.$t("Error deleting file"),
              description: deleteFile.NAME,
            });
          }
        })
        .always(() => {
          this.changeSpinning(false);
        });
    },
    onback(data) {
      let index = this.invoices.findIndex(
        (x) => x.ID == this.document_record.ID
      );
      this.invoices[index] = this.document_record;
      this.visible_doc = data.visible_doc;
      if (data.remove_elem) {
        if (data.updateStatus) {
          this.goSteps(this.document_record);
        }
        if (data.updateStatistic) {
          this.updateStatisticNumber(data.updateStatistic);
        }
        let indx = this.invoices.findIndex((x) => x.ID == data.remove_elem);
        let removed = this.invoices.splice(indx, 1);
        if (data.unshift_elem === true) {
          removed[0]["time_change"] = moment().format("YYYY-DD-MM HH:mm:ss");
          this.invoices.unshift(removed[0]);
        }
      }
      this.resize();
    },
    onpreview(data) {
      this.previewFile(data.file, data.page);
    },
    changeSpinning(val) {
      this.$emit("changeSpinning", val);
    },
    goSteps(record) {
      let first_stage = this.current == 0 ? true : false;
      this.changeSpinning(true);
      this.$emit("updateCompanyList");
      BX24.callMethod("profile", {}, (profile) => {
        this.profile = profile.data();
        getDocumentAllStage(first_stage, record.ID)
          .done((data) => {
            let item = data ? JSON.parse(data) : {};
            this.document_record = Object.assign({}, record, item);
            if (
              this.document_record.invoiceCorrection &&
              this.document_record.status != "ZAREJESTROWANE"
            ) {
              getDocumentAllStage(
                false,
                this.document_record.invoiceCorrection
              ).always((res) => {
                let correct = JSON.parse(res);
                this.document_record.invoiceCorrection = correct.num_doc;
                this.previewElementOnSteps = correct;
              });
            }
            this.current = this.statusList.findIndex(
              (x) => x.name == this.document_record.status
            );
            if (
              this.profile.ADMIN ||
              this.InitInfo.defaultResponsible.processing.includes(
                this.profile.ID
              )
            ) {
              this.disableFromResponsible = false;
            } else if (this.InitInfo.matrix[this.document_record.my_company]) {
              let {
                ASSISTANT,
                PROCESSING,
                // HUBLIDER,
                ACCESS,
              } = this.InitInfo.matrix[this.document_record.my_company];
              if (
                ASSISTANT.includes(this.profile.ID) ||
                (this.current == 0 && PROCESSING.includes(this.profile.ID)) ||
                // HUBLIDER.includes(this.profile.ID) ||
                (this.current == 2 &&
                  ACCESS.flatMap((x) => x.verifications).includes(
                    this.profile.ID
                  )) ||
                (this.current == 3 &&
                  this.user_setup.bookkeeping.includes(this.profile.ID))
              ) {
                this.disableFromResponsible = false;
              } else {
                this.disableFromResponsible = true;
                if (this.current != 0 && PROCESSING.includes(this.profile.ID)) {
                  this.updateStatisticPercent({
                    status: this.document_record.status,
                    isDelOrAdd: true,
                  });
                  this.onback({
                    visible_doc: true,
                    remove_elem: this.document_record.ID,
                  });
                  return;
                }
              }
            } else {
              this.disableFromResponsible = true;
            }
            this.visible_doc = false;
          })
          .fail((e) => {
            console.error(e);
            this.$message.error(this.$t("Error loading document"));
          })
          .always(() => {
            this.changeSpinning(false);
            BX24.fitWindow();
          });
      });
    },
    handleReturnToStepBack() {
      this.changeSpinning(true);
      var next = this.statusList[this.current - 1]["name"];
      var prev = this.document_record.status;
      returnToStepBack(this.document_record.mainid, next)
        .done((data) => {
          var res = JSON.parse(data);
          this.updateStatisticNumber({ prev, next });
          this.document_record.status = res.status;

          this.onback({
            visible_doc: true,
            remove_elem: this.document_record.ID,
            unshift_elem: true,
            updateStatus: true,
          });
        })
        .fail((e) => {
          console.err(e);
          this.changeSpinning(false);
        });
    },
    getColumnsAndFilesForExport() {
      var files_for_export = this.invoices
        .filter((x) => this.selectedRowKeys.includes(x.key))
        .map((x) => x.mainid);
      var columns_export = [
        "NAME",
        ...this.tableColumns.all
          .filter((x) => this.controlTableColumns.checkedList.includes(x.title))
          .map((x) => x.dataIndex),
      ];

      return { files_for_export, columns: columns_export };
    },
    handleGetExcel() {
      this.uploadingExcel = true;
      getExcel(this.getColumnsAndFilesForExport())
        .done((req) => {
          let res = JSON.parse(req);

          var link = document.createElement("a");
          link.setAttribute("href", res.link);
          link.setAttribute("download", "download.xlsx");
          onload = link.click();
        })
        .fail((err) => {
          console.error("getExcel", err);
        })
        .always(() => {
          this.uploadingExcel = false;
        });
    },
    handlerReportModalSubmit() {
      this.changeSpinning(true);
      if (this.selectedRowKeys.length) {
        this.handleGetExcel();
      } else {
        this.updateSelectedColumns();
      }
      this.visibleControlColumnsModal = false;
      this.changeSpinning(false);
    },
    handlerSaveReport() {
      this.InitInfo.reports.invoices[
        this.reportInputValue
      ] = this.tableColumns.all
        .filter((x) => this.controlTableColumns.checkedList.includes(x.title))
        .map((x) => x.dataIndex);

      saveReports("invoices", this.InitInfo.reports.invoices).always((res) => {
        if (res == "success") {
          this.$notification.success({
            message: "Report saved",
            description: this.reportInputValue,
          });
        } else {
          this.$notification.error({
            message: "Error report save",
            description: this.reportInputValue,
          });
        }
      });
    },
    handlerSelectReport(name) {
      this.controlTableColumns.checkedList = this.tableColumns.all
        .filter((x) =>
          this.InitInfo.reports.invoices[name].includes(x.dataIndex)
        )
        .map((x) => x.title);
      this.$refs.invoiceTableTransfer.getMock();
    },
    handlerDeleteReport() {
      delete this.InitInfo.reports.invoices[this.reportInputValue];

      this.reportInputValue = "";
      saveReports("invoices", this.InitInfo.reports.invoices).always((res) => {
        if (res == "success") {
          this.$notification.success({
            message: "Report deleted",
            description: this.reportInputValue,
          });
        } else {
          this.$notification.error({
            message: "Report delete",
            description: this.reportInputValue,
          });
        }
      });
    },
    checkForInvolvement(userID) {
      var mas = [
        ...this.user_setup.responsible,
        ...this.InitInfo.defaultResponsible.processing,
        ...this.InitInfo.defaultResponsible.verification,
      ];
      if (mas.includes(userID)) return true;
      for (let i in this.InitInfo.matrix) {
        mas = [
          ...this.InitInfo.matrix[i].PROCESSING,
          // ...this.InitInfo.matrix[i].ASSISTANT,
          // ...this.InitInfo.matrix[i].HUBLIDER,
          // ...(this.InitInfo.matrix[i].ACCESS
          //   ? this.InitInfo.matrix[i].ACCESS.flatMap((x) => x.verifications)
          //   : []),
        ];
        if (mas.includes(userID)) return true;
      }
      return false;
    },
    checkResponsibleUser() {
      this.checkResponsible =
        Boolean(this.responsible.find((el) => el == this.profile.ID)) ||
        BX24.isAdmin();
    },
    async setAllInvoices() {
      this.changeSpinning(true);
      let resp_getInvoices = await getInvoices();
      if (resp_getInvoices.ok) {
        let vals = await resp_getInvoices.json();
        this.invoices = vals["all_invoice"];
        for (let i in this.invoices) {
          this.invoices[i]["key"] = i;
        }

        delete vals.all_invoice;
        this.setStatistic({ vals, statusList: this.statusList });
      } else {
        this.$message.error(this.$t("Error loading files"));
      }
      this.changeSpinning(false);
    },
    resize() {
      setTimeout(
        () =>
          BX24.resizeWindow(
            parseInt($("body #root_block").css("width")),
            parseInt($("body #root_block").css("height"))
          ),
        100
      );
    },
  },
  async mounted() {
    this.locale = ru_RU;

    this.controlTableColumns.plainOptions = this.tableColumns.all
      .map((x) => x.title)
      .sort();
    let userOption = BX24.userOption.get("userTableColumns");

    let adminOption = BX24.appOption.get("adminTableColumns");
    if (userOption) {
      this.controlTableColumns.checkedList = JSON.parse(userOption);
    } else if (adminOption) {
      this.controlTableColumns.checkedList = JSON.parse(adminOption);
    }
    this.updateSelectedColumns();
    if (this.placementDealID === false && this.placementCompanyID === false) {
      await this.setAllInvoices();
    } else {
      if (this.placementDealID !== false) {
        this.handleSearch({ cost_deal: [this.placementDealID] });
      } else if (this.placementCompanyID !== false) {
        this.handleSearch({ kontragent: [this.placementCompanyID] });
      }
    }
    if (this.goToInvoiceData) {
      // if (this.invoices.find((x) => x.ID == this.goToInvoiceData.ID)) {
      this.goSteps(this.goToInvoiceData);
      this.$emit("goToInvoice");
      // } else {
      //   this.$notification.error({
      //     message: this.$t("Not enough rights"),
      //     description: this.$t("You do not have access to view this invoice"),
      //   });
      // }
    }

    let auth = BX24.getAuth();
    this.domain = auth.domain;

    BX24.callMethod("profile", {}, (res) => {
      this.profile = res.data();
      this.checkResponsibleUser();
      this.resize();
      this.isUploadingDisable = !(
        this.profile.ADMIN || this.checkForInvolvement(this.profile.ID)
      );
    });
  },
};
</script>
<style scoped>
.docTable {
  display: flex;
  flex-direction: column;
}
.documentSearch {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.documentSearch > div {
  margin: 5px 0px;
  width: 100%;
  text-align: left;
  align-self: flex-start;
}
.documentSearch .functionalRow {
  display: flex;
  justify-content: space-around;
  margin-bottom: 25px;
}
.documentSearch .functionalRow .documentAdd__btn {
  margin-right: 15px;
  display: flex;
  align-self: center;
}
.documentSearch .functionalRow .search-wrapper {
  width: 100%;
}
.documentTable {
  min-height: 401px;
}
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
.ant-dropdown-link {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.table-operations {
  margin: 10px 0;
  display: flex;
  justify-content: space-around;
}

.table-operations > div {
  margin-right: 10px;
}
</style>
